"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VipTitle = exports.VipInfo = exports.Stopper = exports.Overlay = exports.List = exports.Flyout = exports.CustomerName = exports.Caret = exports.AccountSubSectionHeading = exports.AccountSectionLinkContainer = exports.AccountSectionLink = exports.AccountSectionHeading = exports.AccountMenus = exports.AccountInfoContainer = exports.AccListItem = exports.AccList = exports.AccDDA = void 0;
var _react = require("@linaria/react");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const Caret = exports.Caret = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Caret",
  class: "pl-c16g2ln8"
});
const Flyout = exports.Flyout = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Flyout",
  class: "pl-f1j5xih7"
});
const AccountInfoContainer = exports.AccountInfoContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AccountInfoContainer",
  class: "pl-asaku91"
});
const AccountSectionHeading = exports.AccountSectionHeading = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AccountSectionHeading",
  class: "pl-a1dudmus"
});
const AccountSubSectionHeading = exports.AccountSubSectionHeading = /*#__PURE__*/(0, _react.styled)("p")({
  name: "AccountSubSectionHeading",
  class: "pl-a5plups"
});
const CustomerName = exports.CustomerName = /*#__PURE__*/(0, _react.styled)("a")({
  name: "CustomerName",
  class: "pl-c1qftsyc"
});
const AccountSectionLinkContainer = exports.AccountSectionLinkContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AccountSectionLinkContainer",
  class: "pl-a193rlhc"
});
const AccountSectionLink = exports.AccountSectionLink = /*#__PURE__*/(0, _react.styled)("a")({
  name: "AccountSectionLink",
  class: "pl-awi2jge"
});
const AccountMenus = exports.AccountMenus = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AccountMenus",
  class: "pl-adn1o2r"
});
const AccList = exports.AccList = /*#__PURE__*/(0, _react.styled)("ul")({
  name: "AccList",
  class: "pl-a1bbaw5g"
});
const Stopper = exports.Stopper = /*#__PURE__*/(0, _react.styled)("span")({
  name: "Stopper",
  class: "pl-s1mi4vp5"
});
const Overlay = exports.Overlay = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Overlay",
  class: "pl-o1lbpgmf"
});
const VipInfo = exports.VipInfo = /*#__PURE__*/(0, _react.styled)("div")({
  name: "VipInfo",
  class: "pl-v1r32s0w"
});
const VipTitle = exports.VipTitle = /*#__PURE__*/(0, _react.styled)("span")({
  name: "VipTitle",
  class: "pl-v1juvgzn"
});
const AccListItem = exports.AccListItem = /*#__PURE__*/(0, _react.styled)("li")({
  name: "AccListItem",
  class: "pl-a115iesm"
});
const AccDDA = exports.AccDDA = /*#__PURE__*/(0, _react.styled)("a")({
  name: "AccDDA",
  class: "pl-a92ysau"
});
const List = exports.List = /*#__PURE__*/(0, _react.styled)("ul")({
  name: "List",
  class: "pl-lb2124r"
});